"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LayoutTarget = void 0;
exports.LayoutTarget = {
  name: 'LayoutTarget',
  type: "taxonomy",
  label: "Layout Target",
  autoRoutes: ['list', 'create', 'update'],
  icon: function (_a) {
    var icons = _a.icons;
    return icons.Entities.Block;
  }
};